// extracted by mini-css-extract-plugin
export default {"modalContainer":"D3-z","modalIndicator":"E3-z","prevBtn":"F3-z","nextBtn":"G3-z","body":"H3-z","footer":"I3-z"};